// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".guess{padding:10px}.guess .iframe{height:40vw;width:100%}.guess .answers{display:grid;grid-template-columns:repeat(2,1fr);margin-top:10px;grid-gap:10px}.guess .answers .item{border:1px solid hsla(0,0%,100%,.35);border-radius:4px;color:hsla(0,0%,100%,.35);cursor:pointer;padding:20px;text-align:center;transition:all .2s ease}.guess .answers .item:hover{border:1px solid #fff;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
